/* AddictaLash lash quiz memory (loaded on every page by snippets/al-lash-quiz-memory.liquid).
 * - Saves the last quiz answers in a cookie when someone reaches their results.
 * - Relabels "Take the lash quiz" buttons to "See results" for that visitor.
 * - Clicking any quiz link (or landing on a quiz page) asks: go back to my results, or take another quiz. */
(function () {
  'use strict';

  var cfg = window.AlqMemoryConfig || {};
  var COOKIE = 'al_lash_quiz';
  var MAX_AGE = 60 * 60 * 24 * 180; // 6 months
  var QUIZ_PATH = /^\/pages\/[^/?#]*quiz[^/?#]*\/?$/i;
  var TAKE_LABEL = /take.*quiz/i;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- cookie ---------- */

  function read() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!match) return null;
    try {
      var data = JSON.parse(decodeURIComponent(match[1]));
      return data && data.a && data.a.look && data.a.eyeshape ? data : null;
    } catch (e) { return null; }
  }

  function preferencesAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.preferencesProcessingAllowed === 'function') return cp.preferencesProcessingAllowed();
    } catch (e) { /* fall through */ }
    return true;
  }

  function save(answers, resultName, emailGiven) {
    if (!preferencesAllowed()) return;
    var value = encodeURIComponent(JSON.stringify({ a: answers, r: resultName || '', e: emailGiven ? 1 : 0, t: Date.now() }));
    document.cookie = COOKIE + '=' + value + '; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }

  /* ---------- quiz links + labels ---------- */

  function quizPath(link) {
    if (!link || !link.getAttribute) return null;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return null;
    var url;
    try { url = new URL(href, location.href); } catch (e) { return null; }
    if (url.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) return null;
    return QUIZ_PATH.test(url.pathname) ? url.pathname : null;
  }

  function relabel() {
    if (!read()) return;
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (link) {
      if (!quizPath(link) || link.dataset.alqRelabelled) return;
      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue.trim();
        if (text && TAKE_LABEL.test(text)) {
          var label = text === text.toUpperCase() ? cfg.seeResults.toUpperCase() : cfg.seeResults;
          node.nodeValue = node.nodeValue.replace(text, label);
          link.dataset.alqRelabelled = '1';
          link.setAttribute('aria-label', label);
        }
      }
    });
  }

  /* ---------- popup ---------- */

  var modal;
  var lastFocus;

  function buildModal() {
    if (modal) return modal;
    var style = document.createElement('style');
    style.textContent = [
      '.alqm{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;font-family:"Optima",var(--font-heading-family,serif);letter-spacing:normal}',
      '.alqm[hidden]{display:none}',
      '.alqm__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55)}',
      '.alqm__panel{position:relative;width:100%;max-width:440px;background:#fff;color:#000;border-radius:6px;padding:40px 28px 28px;text-align:center;box-shadow:0 20px 50px rgba(0,0,0,.25);animation:alqm-in .2s ease-out}',
      '@keyframes alqm-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}',
      '.alqm__close{position:absolute;top:8px;right:10px;width:40px;height:40px;border:0;background:none;font-size:28px;line-height:1;cursor:pointer;color:#000}',
      '.alqm__title{font-family:inherit;font-size:24px;font-weight:600;line-height:1.25;margin:0 0 10px;color:#000}',
      '.alqm__text{font-size:17px;font-weight:600;line-height:1.4;color:#a85a73;margin:0 0 26px}',
      '.alqm__btn{display:block;width:100%;font-family:inherit;font-size:15px;font-weight:600;padding:15px 18px;cursor:pointer;letter-spacing:normal;-webkit-appearance:none;appearance:none}',
      '.alqm__btn--primary{background:#000;color:#fff;border:1px solid #e9c2bb;border-radius:5px}',
      '.alqm__btn--secondary{background:#fff;color:#000;border:1px solid #000;border-radius:4px;margin-top:10px}',
      '.alqm__btn:hover{opacity:.85}',
      '.alqm__btn:focus-visible,.alqm__close:focus-visible{outline:2px solid #a85a73;outline-offset:2px}'
    ].join('');
    document.head.appendChild(style);

    modal = document.createElement('div');
    modal.className = 'alqm';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'alqm-title');
    modal.innerHTML =
      '<div class="alqm__backdrop" data-alqm-close></div>' +
      '<div class="alqm__panel">' +
      '<button type="button" class="alqm__close" data-alqm-close aria-label="Close">&times;</button>' +
      '<h2 class="alqm__title" id="alqm-title"></h2>' +
      '<p class="alqm__text"></p>' +
      '<button type="button" class="alqm__btn alqm__btn--primary" data-alqm-results></button>' +
      '<button type="button" class="alqm__btn alqm__btn--secondary" data-alqm-retake></button>' +
      '</div>';
    modal.querySelector('.alqm__title').textContent = cfg.title;
    modal.querySelector('.alqm__text').textContent = cfg.text;
    modal.querySelector('[data-alqm-results]').textContent = cfg.resultsButton;
    modal.querySelector('[data-alqm-retake]').textContent = cfg.retakeButton;
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-alqm-close]')) close();
      else if (e.target.closest('[data-alqm-results]')) choose('results');
      else if (e.target.closest('[data-alqm-retake]')) choose('retake');
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var items = modal.querySelectorAll('button');
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    return modal;
  }

  var pendingTarget = null;

  function open(targetPath) {
    pendingTarget = targetPath || null;
    buildModal();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('[data-alqm-results]').focus();
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function pageQuiz() {
    var root = document.querySelector('[data-alq]');
    return root && root.alqQuiz ? root.alqQuiz : null;
  }

  function choose(action) {
    var saved = read();
    var quiz = pageQuiz();
    close();
    if (quiz) {
      if (action === 'results' && saved) quiz.showSaved(saved.a, saved.e);
      else quiz.restart();
      return;
    }
    var path = action === 'results' ? cfg.resultsUrl : (pendingTarget || cfg.resultsUrl);
    location.href = path + (path.indexOf('?') === -1 ? '?' : '&') + 'alq=' + action;
  }

  /* ---------- wiring ---------- */

  // Any click on a quiz link, anywhere on the site.
  document.addEventListener('click', function (e) {
    if (designMode || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href]');
    var path = quizPath(link);
    if (!path || !read()) return;
    e.preventDefault();
    open(path);
  }, true);

  // On a quiz page: honour ?alq=results / ?alq=retake, otherwise ask if they have saved results.
  var handledQuiz = false;
  function onQuizReady(quiz) {
    if (handledQuiz || designMode || !quiz) return;
    handledQuiz = true;
    var params = new URLSearchParams(location.search);
    var action = params.get('alq');
    var saved = read();
    if (action) {
      params.delete('alq');
      var qs = params.toString();
      history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    }
    if (action === 'results' && saved) quiz.showSaved(saved.a, saved.e);
    else if (!action && saved) open(location.pathname);
  }

  document.addEventListener('lashquiz:ready', function (e) { onQuizReady(e.detail && e.detail.quiz); });
  document.addEventListener('lashquiz:result', function (e) {
    var d = e.detail || {};
    var previous = read();
    if (d.answers) save(d.answers, d.result, d.emailGiven || (previous && previous.e));
    relabel();
  });
  document.addEventListener('lashquiz:unlocked', function () {
    var saved = read();
    if (saved) save(saved.a, saved.r, true);
  });

  function init() {
    relabel();
    var quiz = pageQuiz();
    if (quiz) onQuizReady(quiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.AlqMemory = { read: read, open: open };
})();
